export const REMOVE_TOP_COMMENT_REQUEST = 'post/REMOVE_TOP_COMMENT_REQUEST';
export const REMOVE_TOP_COMMENT_SUCCESS = 'post/REMOVE_TOP_COMMENT_SUCCESS';
export const REMOVE_TOP_COMMENT_FAILURE = 'post/REMOVE_TOP_COMMENT_FAILURE';

export function removeTopComment(postId) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: REMOVE_TOP_COMMENT_REQUEST,
    });

    const promise = request.delete(`/_api/posts/${postId}/top-comment`);

    return promise
      .then(post =>
        dispatch({
          type: REMOVE_TOP_COMMENT_SUCCESS,
          payload: post,
        })
      )
      .catch(() =>
        dispatch({
          type: REMOVE_TOP_COMMENT_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/remove-top-comment.js